import React from 'react';
import { View, Image, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

const Status = ({ meetStatus }) => {

    const backgroundColor = meetStatus ? "green" : "gray";

    return(
        <View style={[styles.containerStyle, { backgroundColor: backgroundColor }]} >
            <Image
                source={require('../../img/icons/icon_check.png')}
                style={{ height: 20, width: 20 }}
                resizeMode={'contain'}
            />
        </View>
    )
};

const styles = StyleSheet.create({
    containerStyle: {
        height: 32,
        width: 32,
        borderRadius: 45,
        justifyContent: "center",
        alignItems: "center",
        padding: 6
    }
})

Status.propTypes = {
    meetStatus: PropTypes.bool.isRequired
};

export { Status };
